import React from 'react';
import './CustomInputField.css';
import FileUpload from '../../images/icons/file_upload.svg';

const CustomFileUpload = props => {
  const FileUploadHandler = (id = null, event) => {
    if (id) {
      let a = document.getElementById(id);
      try {
        a.click();
      } catch (e) {}
      document.getElementById(id + '_error').style.display = 'none';
    }
  };
  const ShowChangedPic = id => {
    let a = document.getElementById(id);
    if (!a.files[0]) {
      let doc_error = document.getElementById(id + '_error');
      doc_error.style.display = 'block';
      doc_error.innerHTML = 'No File is selected';
    }
    if (a.files[0]) {
      let file_container, list;
      try {
        file_container = a.files[0];
      } catch (e) {
        return false;
      }

      let file = file_container;
      let img;
      if (file.type === 'application/pdf') {
        img = document.createElement('iframe');
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.border = 'ridge';
      } else {
        img = document.createElement('img');
      }
      let reader = new FileReader();
      reader.onloadend = function() {
        img.src = reader.result;
      };
      if (file.type != 'application/pdf') {
        img.onclick = function() {
          let win = window.open();
          win.document.write(
            '<iframe width="100%" height="100%" src="' +
              img.src +
              '" frameborder="0" allowfullscreen></iframe>'
          );
        };
      } else {
        img.onclick = function() {
          let win = window.open();
          win.document.write(
            '<iframe width="100%" height="100%" src="' +
              img.src +
              '" frameborder="0" allowfullscreen></iframe>'
          );
        };
      }
      reader.readAsDataURL(file);

      list = a.parentNode.parentNode.children[1];
      if (!list) {
        list = a.parentNode.parentNode.children[1];
      }
      if (list.hasChildNodes()) {
        list.removeChild(list.childNodes[0]);
      }
      list.appendChild(img);
      // File Handler from parent component
      try {
        let b = props.file_handler(props.val.id);
      } catch (e) {
        // alert({ d: e });
      }
    }
  };

  return (
    <>
      <div
        className="cursor-pointer w-3/4 h-32 mx-auto mt-8 h-auto"
        id={props.val.id + '_container'}
      >
        <div
          className="w-full bg-blue-1000 border-solid items-center text-center border-grey-300 file_type"
          onClick={() => FileUploadHandler(props.val.id, event)}
        >
          <img
            src={FileUpload}
            alt="file_uplaod"
            className="mx-auto mt-10 items-center"
            id={props.val.id + '_image'}
          />
          <div className="w-full text-center opacity-75 text-xs text-black-800 mt-2">
            {props.val.file_caption}
          </div>
          <input
            style={{ position: 'relative', top: '-1000px', overflow: 'hidden' }}
            type="file"
            id={props.val.id}
            onChange={() => ShowChangedPic(props.val.id, event)}
          />
        </div>
        <div
          className="w-full bg-white items-center mt-10 block shadow-md p-4 invisible"
          id={props.val.id + '_area'}
        ></div>
        <div
          className="w-full text-center opacity-75 text-xs text-black-800 mt-2 cursor-pointer hidden"
          onClick={() => FileUploadHandler(props.val.id, event)}
          id={props.val.id + 're_upload'}
        >
          Upload Again
        </div>
      </div>
      <div
        className="w-full text-center opacity-100 text-xs text-red-100 mt-2  hidden"
        id={props.val.id + '_error'}
      ></div>
    </>
  );
};
export default CustomFileUpload;
